import { render } from "./ProcedureSupplierRequirementsInfo.vue?vue&type=template&id=29a24be6&scoped=true"
import script from "./ProcedureSupplierRequirementsInfo.vue?vue&type=script&lang=js"
export * from "./ProcedureSupplierRequirementsInfo.vue?vue&type=script&lang=js"

import "./ProcedureSupplierRequirementsInfo.vue?vue&type=style&index=0&id=29a24be6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a24be6"]])

export default __exports__